import { Component, OnInit, ViewChild } from '@angular/core';
import { MatSort, MatTableDataSource } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ControleSeapService } from '../controle-seap.service';

@Component({
  selector: 'app-lista-matriculas-concluidas',
  templateUrl: './lista-matriculas-concluidas.component.html',
  styleUrls: ['./lista-matriculas-concluidas.component.scss']
})
export class ListaMatriculasConcluidasComponent implements OnInit {

  displayedColumns = ['name', 'penitenciaria', 'cursoName', 'startDate', 'endDate', 'entregue', 'recolhida', 'see'];
  dataSource: any;
  matriculas: any[] = [];
  pendentes = false;

  @ViewChild(MatSort) sort: MatSort;
  constructor(private toastr: ToastrService, private router: Router, private server: ControleSeapService,  private route: ActivatedRoute) {
   
   }

  ngOnInit() {
    this.init();
  }

  open(id) {
    this.router.navigate(['/controle-seap/add-matricula', id])
  }

  newMatricula() {
    this.router.navigate(['/controle-seap/add-matricula'])
  }

  applyFilter(filterValue: string) {
    try{
      filterValue = filterValue.trim(); // Remove whitespace
      filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
      this.dataSource.filter = filterValue;
    } catch {

    }
    
  }

  init() {
    this.matriculas = [];
    this.server.getMatriculasConcluidasStatic().then(res => {
      res.forEach(c => {
        const d = c.val();
        d.id = c.key;
        d.entregue = d.entregue ? d.entregue : false;
        d.recolhida = d.recolhida ? d.recolhida : false;
        d.entreguetext = `$entregue$${d.entregue}`;
        d.recolhidotext = `$recolhida$${d.recolhida}`;
        const b = new Date(d.endDate);
        const a = new Date();
        const diff = b.getTime() - a.getTime();
        // d.timeLeft = Math.ceil(diff/(1000 * 60 * 60 * 24));
        
        if(this.pendentes && d.timeLeft > 10) return;

        // let aux = d.startDate.split("-");
        // d.startDate = aux[2]+'/'+aux[1]+'/'+aux[0];
        // aux = d.endDate.split("-");
        // d.endDate = aux[2]+'/'+aux[1]+'/'+aux[0];

        this.matriculas.push(d);
      });

      this.matriculas.sort((a, b) => a.timeLeft < b.timeLeft ? -1 : 1);
      this.dataSource = new MatTableDataSource(this.matriculas);
      this.dataSource.sort = this.sort;
    });
  }

  remove(id) {
    this.server.removeMatriculaById(id).then(res => {
      if(!res){
        this.toastr.error('Ocorreu um erro, tente novamente');
      } else {
        this.toastr.success('Matrícula removida com sucesso!');
      }
      
      this.init();
    }).catch(err => {
      this.toastr.error('Ocorreu um erro, tente novamente');
    })
    
  }

  concluir(mt) {
    this.server.concluirMatricula(mt).then(res => {
      if(!res){
        this.toastr.error('Ocorreu um erro, tente novamente');
      } else {
        this.server.removeMatriculaById(mt.id).then(res => {
          if(!res){
            this.toastr.error('Ocorreu um erro, tente novamente');
          } else {
            this.toastr.success('Matrícula concluída com sucesso!');
          }
          this.init();
        }).catch(err => {
          this.toastr.error('Ocorreu um erro, tente novamente');
        })
      }
    }).catch(err => {
      this.toastr.error('Ocorreu um erro, tente novamente');
    });
  }

  changeEntregue(mat) {
    this.server.changeEntregue(mat.id, !mat.entregue).then(res => {
      if(!res){
        this.toastr.error('Ocorreu um erro, tente novamente');
      } else {
          this.init();       
      }
    }).catch(err => {
      this.toastr.error('Ocorreu um erro, tente novamente');
    });
  }

  changeRecolhida(mat) {
    this.server.changeRecolhido(mat.id, !mat.entregue).then(res => {
      if(!res){
        this.toastr.error('Ocorreu um erro, tente novamente');
      } else {
          this.init();       
      }
    }).catch(err => {
      this.toastr.error('Ocorreu um erro, tente novamente');
    });
  }

  changeSelect(id) {
    if(id === '0') {
      this.applyFilter('');
    } else if (id === '1') {
      this.applyFilter('$entregue$false');
    } else if (id === '2') {
      this.applyFilter('$recolhida$false');
    } else if (id === '3') {
      this.applyFilter('$entregue$true');
    } else if (id === '4') {
      this.applyFilter('$recolhida$true');
    }
  }

  restaurar(mt) {
    console.log(mt);
    this.server.restaurarMatricula(mt).then(res => {
      if(!res){
        this.toastr.error('Ocorreu um erro, tente novamente');
      } else {
        this.server.removeMatriculaConcluidaById(mt.id).then(res => {
          if(!res){
            this.toastr.error('Ocorreu um erro, tente novamente');
          } else {
            this.toastr.success('Matrícula restaurada com sucesso!');
          }
          this.init();
        }).catch(err => {
          this.toastr.error('Ocorreu um erro, tente novamente');
        })
      }
    }).catch(err => {
      this.toastr.error('Ocorreu um erro, tente novamente');
    });
  }

}
